export default __webpack_public_path__ + "static/media/React.a023942b.png";